<app-temp-modal-cadastro #modalCadastro (closed)="onClose()" [textHeader]="textHeader">
  <form [formGroup]="cadastroForm" (ngSubmit)="submitForm()">
    <div class="row">
      <div class="form-group col-sm-12">
        <label class="label-required">Nome</label>
        <input [disableControl]="loading['registro']" type="text" class="form-control" formControlName="nome" />
        <show-errors [control]="cadastroForm.controls.nome"></show-errors>
      </div>
      <div class="form-group form-check col-12 col-sm-12 col-lg-12 check-form">
        <label></label>
        <div class="checkbox-fade fade-in-default">
          <label>
            <input type="checkbox" formControlName="automatico">
            <span class="cr">
              <i class="cr-icon icofont icofont-ui-check txt-default"></i>
            </span>
            <span class="text-inverse">
              Automático
            </span>
          </label>
        </div>
      </div>
    </div>

    <div class="alert alert-danger" *ngIf="errors">
      <span>{{ errors }}</span>
    </div>

    <button [disabled]='loading["registro"]' type="submit" (click)="validaForm()" class="btn btn-primary ripple light">
      <app-loading [texto]="'Salvar'" [loading]="loading['registro']"></app-loading>
    </button>
    <button [disabled]='loading["registro"]' type="button" class="btn btn-default ripple"
      (click)="modalCadastro.hide()">Cancelar</button>
  </form>
</app-temp-modal-cadastro>